export const defaultVehicles = [
  {
    name: 'Rolls-Royce Spectre',
    category: 'luxury',
    tagline: 'The pinnacle of electric luxury and bespoke craftsmanship',
    imageUrl: '/images/Rolls-Royce Specture.jpg',
    features: ['All-Electric Powertrain', 'Bespoke Interior', 'Starlight Headliner', 'Spirit of Ecstasy', 'Planar Suspension', 'Whisper-Quiet Cabin'],
    status: 'available',
    sortOrder: 1,
  },
  {
    name: 'Mercedes-Benz E43 AMG',
    category: 'luxury',
    tagline: 'Executive elegance meets AMG performance',
    imageUrl: '/images/Mercedes Benz E43 AMG.jpg',
    features: ['AMG Performance', 'Leather Interior', 'Panoramic Roof', 'Premium Sound System', 'Ambient Lighting', 'Adaptive Cruise Control'],
    status: 'available',
    sortOrder: 2,
  },
  {
    name: 'Mercedes-Benz G63 AMG',
    category: 'suv',
    tagline: 'Iconic G-Class power with unmistakable presence',
    imageUrl: '/images/Mercedes G63 AMG.jpg',
    features: ['AMG Biturbo V8', 'All-Wheel Drive', 'Luxury Seating', 'Off-Road Capability', 'Premium Interior', 'Advanced Driver Assist'],
    status: 'available',
    sortOrder: 3,
  },
  {
    name: 'Dodge Challenger SRT',
    category: 'sports',
    tagline: 'American muscle with raw, unapologetic power',
    imageUrl: '/images/Dodge Challenger SRT.JPG',
    features: ['SRT Performance', 'Sport Exhaust', 'Performance Brakes', 'Premium Interior', 'Track Mode', 'Hemi Power'],
    status: 'available',
    sortOrder: 4,
  },
  {
    name: 'Toyota Camry XSE',
    category: 'sedan',
    tagline: 'Sporty refinement with everyday reliability',
    imageUrl: '/images/Toyota Camry Xse.jpg',
    features: ['XSE Sport Styling', 'Leather-Trim Seats', 'Smart Safety Sense', 'Apple CarPlay', 'Dual-Zone Climate', 'Premium Audio'],
    status: 'available',
    sortOrder: 5,
  },
  {
    name: 'Toyota Land Cruiser',
    category: 'suv',
    tagline: 'Legendary durability built for any terrain',
    imageUrl: '/images/Toyota Land Cruiser.jpg',
    features: ['4WD Capability', 'Spacious Cabin', 'Advanced Safety', 'Premium Comfort', 'Towing Capacity', 'All-Terrain Performance'],
    status: 'available',
    sortOrder: 6,
  },
  {
    name: 'Jetour T2 XWD',
    category: 'suv',
    tagline: 'Bold design meets modern adventure-ready tech',
    imageUrl: '/images/Jetour T2 XWD.jpg',
    features: ['XWD All-Wheel Drive', 'Panoramic Sunroof', 'Smart Connectivity', 'Spacious Interior', 'Advanced Safety', 'Off-Road Ready'],
    status: 'available',
    sortOrder: 7,
  },
];
